export const SET_CAT_SUBJECT_DOMAINS = 'cat-domain/SET_CAT_SUBJECT_DOMAINS';
export const RESET_CAT_SUBJECT_DOMAINS = 'cat-domain/RESET_CAT_SUBJECT_DOMAINS';
export const SET_SELECTED_SUBJECT_ID = 'cat-domain/SET_SELECTED_SUBJECT_ID';
export const SET_CAT_STATS = 'cat-domain/SET_CAT_STATS';



// WEBPACK FOOTER //
// ./src/app/cat-domain/store/mutation-types.js